import { Col, Form, Row } from "antd";
import { type FC, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { AddButton } from "../../../../../../../components/FeatureButtons/AddButton";
import { SelectDynamic } from "../../../../../../../components/Form/formComponents";
import { FormComponent } from "../../../../../../../components/Form/types/types";
import { ResourceName } from "../../../../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../../../../core/router/types/routerTypes";

export type PromptDataSelectorProps = {
    cardProfileType?: string;
};

export const PromptDataSelector: FC<PromptDataSelectorProps> = ({ cardProfileType }) => {
    const [selectedValue, setSelectedValue] = useState<string>();

    const fieldConfig = {
        urlToFetchOptions: "configurations/prompt-types",
        optionDisplayPropName: "key",
        optionValuePropName: "value",
        name: "promptDataList",
        component: FormComponent.SELECT_DYNAMIC,
        translationKeys: { label: "promptDataList" },
    };

    const navigate = useNavigate();
    const { id, appProfileId } = useParams();
    const onAdd = () =>
        navigate(
            `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${id}/${ResourceName.APPLICATION_PROFILE_PROMPT_DATA}/create?promptDataProfile=${selectedValue}&type=${cardProfileType}`,
        );

    return (
        <Row>
            <Col span={21}>
                <Form.Item>
                    <SelectDynamic name="" label="" fieldConfig={fieldConfig} onChange={setSelectedValue} value={selectedValue} />
                </Form.Item>
            </Col>
            <Col offset={1} span={2}>
                <AddButton callback={onAdd} isDisabled={!selectedValue} />
            </Col>
        </Row>
    );
};
